module.exports = __webpack_public_path__ + "static/media/arrow_drop_down-24px.322e5a60.svg";